import styled from 'styled-components'
import chroma from 'chroma-js'
import { app } from 'src/configuration'

import { mq, sizes } from '../../theme'
import Highlight from '../Highlight'
import { lighten } from '../../utils/ColorUtils'

const publicPathPrefix = app.ASSET_PREFIX

export const Container = styled.div`
  position: relative;
  height: 100%;
  min-height: 30rem;

  @media ${mq(sizes.desktop)} {
    min-height: initial;
  }
`
export const Background = styled.div<{ backgroundColor?: string }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background-image: url('${publicPathPrefix}/images/Textures/grudge.png');
  background-repeat: repeat;
  background-position: center center;
  background-color: ${({ backgroundColor, theme }) =>
    backgroundColor
      ? lighten(chroma(backgroundColor), 0.15).hex('rgb')
      : theme.colors.greenApple ?? 'green'};
`

export const Foreground = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  height: 100%;
  padding: 2rem 2rem 4rem;

  @media ${mq(sizes.desktop)} {
    padding-top: 7rem;
    padding: 6rem 4rem;
  }
`

export const Highlights = styled.div`
  display: flex;
  flex-flow: column nowrap;
  max-width: 30rem;
`

export const FirstHighlight = styled(Highlight)`
  ${({ theme }) => theme.textStyles.text_bold_condensed_16};
  & span {
    background-color: ${({ backgroundColor, theme }) =>
      backgroundColor
        ? lighten(chroma(backgroundColor), 0.3).hex('rgb')
        : theme.colors.greenEmerald ?? 'green'};
  }
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.text_bold_condensed_14};
  }
`

export const SecondHighlight = styled(Highlight)`
  ${({ theme }) => theme.textStyles.text_bold_24};

  & span {
    padding: 0.2rem 0.8rem;
  }

  @media ${mq(sizes.desktop)} {
    & span {
      line-height: 1.6;
    }
  }
`

export const Buttons = styled.div`
  margin-top: 3.6rem;
`
